import { SubscriptionButtonProps } from '../types';

// TODO implement
const useViewModel = (props: SubscriptionButtonProps) => props;

export { useViewModel };
